/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_GenderInputs */

const en_dialog_gender = /** @type {(inputs: Dialog_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gender`)
};

const es_dialog_gender = /** @type {(inputs: Dialog_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Género`)
};

/**
* | output |
* | --- |
* | "Gender" |
*
* @param {Dialog_GenderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_gender = /** @type {((inputs?: Dialog_GenderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_GenderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_gender(inputs)
	return en_dialog_gender(inputs)
});